import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import React from "react";
import {numberFormatter} from "../../utils/formatters/numberFormatter";

export enum TextSize {
    Small = 'Small',
    Medium = 'Medium',
    Large = 'Large'
}

const useStyles = makeStyles({
    label: {
        fontSize: (props: TextSizeProps) => `${props.labelSize === TextSize.Large ? '16px'
            : props.labelSize === TextSize.Medium ? '14px'
                : props.labelSize === TextSize.Small ? '12px' : '12px'}`,
        lineHeight: "10px",
        color: "#b9babd",
        marginTop: "2px",
        fontWeight: 500,
        marginBottom: (props: TextSizeProps) => `${props.labelSize === TextSize.Large ? '10px'
            : props.labelSize === TextSize.Medium ? '9px'
                : props.labelSize === TextSize.Small ? '6px' : '6px'}`,
    },
    value: {
        fontSize: (props: TextSizeProps) => `${props.valueSize === TextSize.Large ? '22px'
            : props.valueSize === TextSize.Medium ? '18px'
                : props.valueSize === TextSize.Small ? '14px' : '14px'}`,
        fontWeight: 600,
        lineHeight: "18px",
        marginTop: "0px",
        marginBottom: "6px",
    },
    valueAmount: {
        fontSize: (props: TextSizeProps) => `${props.valueSize === TextSize.Large ? '24px'
            : props.valueSize === TextSize.Medium ? '20px'
                : props.valueSize === TextSize.Small ? '16px' : '18px'}`,
        weight: "600",
        lineHeight: "18px",
        marginTop: "0px",
        marginLeft: "4px",
        marginBottom: "6px",
    },
    contentWithButton: {
        display: 'flex',
        marginTop: '10px',
        '& > p': {
            alignSelf: 'center'
        }
    },
    iconButton: {
        marginLeft: '10px'
    },
    wrapIcon: {
        verticalAlign: 'middle',
        display: 'inline-flex'
    }
});

interface TextSizeProps {
    labelSize?: TextSize;
    valueSize?: TextSize;
}

export interface ILabelWithDataProps extends TextSizeProps {
    label: string;
    value: any;
    icon?: React.ReactNode;
    format?: 'number' //ver esto, lo pongo asi por si hay que extender a mas formatos
    codCurrency?: string;

}

function LabelWithData(props: ILabelWithDataProps) {
    const classes = useStyles(props);
    let valueAsString: string;

    if (!props.value)
        props?.format === 'number' ? valueAsString = "0,00"
            : valueAsString = "-";
    else
        valueAsString = props?.format === 'number' ? numberFormatter.toStringWithAmount(props.value, props?.codCurrency)
            : String(props.value);

    return (
        <div>
            <p className={classes.label}>{props.label}</p>
            <div className={classes.wrapIcon}>{props?.icon} <p
                className={`${classes.value} ${classes.wrapIcon}`}
            >{valueAsString}</p>
            </div>
        </div>
    );
}

interface ILabelWithDataAmountProps extends TextSizeProps {
    label: string;
    value: number | null | undefined;
    codCurrency?: string;
    colorValue?: string;
    highlightValue?: boolean
}

function LabelWithDataAmount(props: ILabelWithDataAmountProps) {
    const classes = useStyles(props);
    let valueAsString: string;

    if ((!props.value) && (props.value !== 0))
        valueAsString = "-";
    else
        valueAsString = numberFormatter.toStringWithAmount(props.value, props?.codCurrency);

    return (
        <div>
            <p className={classes.label}>{props.label}</p>
            <p className={classes.valueAmount} style={{color: props.colorValue || 'black'}}>
                {props.highlightValue ? <mark>{valueAsString}</mark>
                    : valueAsString}
            </p>
        </div>
    );
}

interface ILabelWithDataPercentageProps extends TextSizeProps {
    label: string;
    value: number | null | undefined;
}

function LabelWithDataPercentage(props: ILabelWithDataPercentageProps) {
    const classes = useStyles(props);
    let valueAsString: string;

    if ((!props.value) && (props.value !== 0))
        valueAsString = "-";
    else
        valueAsString = numberFormatter.toStringWithPercentage(props.value);

    return (
        <div>
            <p className={classes.label}>{props.label}</p>
            <p className={classes.valueAmount}>{valueAsString}</p>
        </div>
    );
}

interface ILabelWithButtonProps extends TextSizeProps {
    label: string;
    disabled?: boolean;
    onClick: () => void;
}

function LabelWithButton(props: ILabelWithButtonProps) {
    const classes = useStyles(props);

    return (
        <div className={classes.contentWithButton}>
            <p className={classes.label}>{props.label}</p>
            <IconButton
                color="primary"
                size="small"
                disabled={props.disabled}
                className={classes.iconButton}
                onClick={props.onClick}>
                <SearchIcon/>
            </IconButton>
        </div>
    );
}

interface ILabelWithChildrenProps extends TextSizeProps {
    label: string;
    children?: React.ReactElement;
}

function LabelWithChildren(props: ILabelWithChildrenProps) {
    const classes = useStyles(props);

    return (
        <div>
            <p className={classes.label}>{props.label}</p>
            {
                (!!props.children) ?
                    props.children
                    :
                    <div className={classes.wrapIcon}>
                        <p className={`${classes.value} ${classes.wrapIcon}`}>-</p>
                    </div>
            }
        </div>
    );
}

export {LabelWithData, LabelWithDataAmount, LabelWithDataPercentage, LabelWithButton, LabelWithChildren}